import { Country } from "../../api";
import useCountries from "./useCountries";
import useCountriesFeatureFlags from "./useCountriesFeatureFlags";

const useSignupCountries = (): { countries: Country[], error?: Error, loading: boolean } => {
  const { countries, error: countriesError, loading: countriesLoading } = useCountries();
  const { features, error: signupCountriesError, loading: featuresLoading } = useCountriesFeatureFlags();

  const signupCountries = countries.filter(country => features.signUpAvailable.includes(country.code));
  const error = countriesError || signupCountriesError;
  const loading = countriesLoading || featuresLoading;

  return { countries: signupCountries, error, loading };
}

export default useSignupCountries;
